import type { App, Plugin } from 'vue';
import { getInstance } from './i18n';

export default {
  install(app: App) {
    const i18n = getInstance() as Plugin;

    app.use(i18n);
  },
};
